import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getProvinces } from '../../api/destinationApi';
import { Seo, Loading } from '../shared';
import MediaFrame from '../shared/MediaFrame';
import '../../styles/guides.scss';
import '../../styles/media.scss';

function ProvincesPage() {
	const [provinces, setProvinces] = useState([]);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		getProvinces()
			.then((res) => setProvinces(res.data || []))
			.catch(() => setProvinces([]))
			.finally(() => setLoading(false));
	}, []);

	return (
		<div className="hub-page">
			<Seo
				title="Explore Nepal by Province"
				path="/provinces"
				description="Nepal's seven federal provinces, each linking to its districts and destinations — the same structure Nepal actually governs itself by."
			/>

			<MediaFrame icon="fa-landmark" category="province" alt="Explore by Province" variant="hero" className="hub-hero">
				<div className="container text-center hub-hero__content">
					<i className="fas fa-landmark hub-hero__icon" aria-hidden="true" />
					<h1 className="text-white mb-2">Explore by Province</h1>
					<p className="text-white hub-hero__tagline">Nepal's seven federal provinces — pick one to see its districts and destinations.</p>
				</div>
			</MediaFrame>

			<section className="container hub-page__body">
				{loading && <Loading />}

				{!loading && provinces.length > 0 && (
					<div className="guide-grid">
						{provinces.map((p) => (
							<Link key={p.slug} to={`/provinces/${p.slug}`} className="guide-card guide-card--with-media">
								<MediaFrame category="province" seed={p.slug} alt={p.name} variant="thumb" />
								<div className="guide-card__body">
									<h3 className="guide-card__title">{p.name}</h3>
									{p.description && <p className="guide-card__summary">{p.description}</p>}
								</div>
							</Link>
						))}
					</div>
				)}
			</section>
		</div>
	);
}

export default ProvincesPage;
